import * as moment from 'moment'
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui'
import * as React from 'react'
import styled from 'styled-components'

const CalendarAppointment = restProps => {
  const children = () => {
    const startDay = new Date(restProps.data.startDate).getUTCDate()
    const endDay = new Date(restProps.data.endDate).getUTCDate()

    return (
      <StyledCalendarAppointment isBordered={!(startDay === endDay) && (restProps.data.endDate !== restProps.data.startDate)} onClick={restProps.onDoubleClick} circleColor={restProps.data.color}>
        <div className='colorCircle' />
        <div className='time'>
          {moment(restProps.data.startDate).format('HH:mm')}
        </div>
        <div title={restProps.data.orgName} className='organization'>
          {restProps.data.orgName}
        </div>
      </StyledCalendarAppointment>
    )
  }


  return (<Appointments.Appointment
    {...restProps}
    style={{ background: 'white', width: "99%", borderRadius: '4px', boxSizing: 'border-box' }}

    children={children()}
  />)
}
export default CalendarAppointment


const StyledCalendarAppointment = styled.div`
  width: 100%;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-weight: normal;
  font-size: 13px;
  transition: 400ms;
  border-radius: 4px;
  background: white;
  //height: 22px;
  padding-left: 5px;
  padding-right: 10px;
  box-sizing: border-box;

  ${p => p.isBordered ? 'border: 1px solid #7EACF7;' : ''}
  
  &:hover {
    background: #F1F3F4;
  }

  .colorCircle {
    border-radius: 1000px;
    border: 4px solid ${p => p.circleColor};
    background: ${p => p.circleColor};
    padding: 0;
    width: 0;
    margin-right: 5px;
  }

  .time {
    font-size: 14px;
    font-weight: normal;
    margin-right: 5px;

  }

  .organization {
    font-size: 14px;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-wrap: avoid;
    text-overflow: ellipsis;

  }
`